import React, { ReactElement } from 'react';
import cx from 'classnames';
import { getGoogleLogo, getMagentaLogo } from '../../svg-assets';
import './LogoLockup.scss';

interface Props {
  isOverlay?: boolean;
}

export function LogoLockup({ isOverlay }: Props): ReactElement {
  return (
    <div
      className={cx('logo-lockup', {
        'logo-lockup--overlay': isOverlay,
      })}
    >
      <a href="https://ai.google/" target="_blank" rel="noopener noreferrer">
        {getGoogleLogo(isOverlay)}
      </a>
      <a href="https://g.co/magenta" target="_blank" rel="noopener noreferrer">
        {getMagentaLogo(isOverlay)}
      </a>
    </div>
  );
}
